import { doctorBffApi, InvalidateArr } from '@/modules';
import { wrapError } from '../error';
import {
  MasterClearPayload,
  PersistSuggestionPayload,
  ScratchMhoSuggestionService
} from './scratchMhoSuggestion.service';

export const scratchSuggestionApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    persistSuggestion: builder.mutation<void, PersistSuggestionPayload>({
      queryFn: (payload) =>
        ScratchMhoSuggestionService.getInstance()
          .persistSuggestion(payload)
          .then(() => ({ data: {} as any }))
          .catch(wrapError),
      invalidatesTags: (result, error, payload) => {
        const patientId = payload.activeSe.patient.id;
        const arr: InvalidateArr = ['Dashboard'];

        const isDrawer = payload.suggestion.suggestionType === 'drawer';
        const isClear = payload.suggestion.suggestionType === 'clear';

        if (isDrawer || isClear || hasMho(payload)) {
          arr.push(
            { type: 'MedicalHo', id: patientId },
            { type: 'SurgeryInfo', id: patientId } // for ASA prediction update
          );
        }

        if (!isDrawer && hasAllergies(payload)) {
          arr.push({ type: 'Allergy', id: patientId });
        }

        return arr;
      }
    }),

    masterClear: builder.mutation<void, MasterClearPayload>({
      queryFn: (payload) =>
        ScratchMhoSuggestionService.getInstance()
          .masterClear(payload)
          .then(() => ({ data: {} as any }))
          .catch(wrapError),
      invalidatesTags: (result, error, payload) => {
        const patientId = payload.activeSe?.patient.id;

        return [
          'Dashboard',
          { type: 'MedicalHo', id: patientId },
          { type: 'SurgeryInfo', id: patientId }, // for ASA prediction update
          { type: 'Allergy', id: patientId }
        ];
      }
    })
  }),
  overrideExisting: false
});

function hasAllergies(payload: PersistSuggestionPayload) {
  return (
    payload.category === 'ALLERGIES' ||
    getReqBody(payload).some((data) => data.category === 'ALLERGIES')
  );
}

function hasMho(payload: PersistSuggestionPayload) {
  return (
    payload.category !== 'ALLERGIES' ||
    getReqBody(payload).some((data) => data.category !== 'ALLERGIES')
  );
}

function getReqBody(payload: PersistSuggestionPayload) {
  const s = payload.suggestion;
  if (s.suggestionType === 'bi-choice') {
    return s.toRequestBody(payload.biChoiceChoice);
  }
  if (s.suggestionType === 'clear') {
    return s.toRequestBody(payload.activeSe);
  }

  return s.toRequestBody();
}

export const { usePersistSuggestionMutation, useMasterClearMutation } =
  scratchSuggestionApi;
